// import React from "react";
// import logo from "@/assets/fstonelogo.png"; // update path if needed
// const PrivacyPolicy = () => {
//   return (
//     <div className="max-w-5xl mx-auto px-4 py-8 text-gray-800 text-sm leading-snug">
//       <h1 className="text-2xl font-semibold mb-4">Privacy Policy</h1>

//       {/* INTRODUCTION */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">1. Introduction</h2>
//         <p className="mb-2">
//           Fstone Technologies operates the job portal application known as{" "}
//           <strong>Hirees</strong> (“Platform”). We are committed to respecting
//           your privacy and protecting the personal information shared with us.
//         </p>
//         <p className="mb-2">
//           This Privacy Policy describes how we collect, use, store, process, and
//           disclose personal information when you access or use the Platform.
//         </p>
//         <p>
//           By using Hirees, you agree to this Privacy Policy. If you do not agree,
//           you should discontinue use of the Platform.
//         </p>
//       </section>

//       {/* INFORMATION COLLECTED */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">
//           2. Types of Personal Information We Collect
//         </h2>
//         <p className="mb-2">
//           Personal Information refers to any information that identifies or can
//           reasonably identify an individual. Depending on your interaction with
//           Hirees, we may collect:
//         </p>

//         <ul className="list-disc ml-5 space-y-1">
//           <li>
//             Personal details including name, email address, mobile number,
//             encrypted password, and location.
//           </li>
//           <li>
//             Resume and profile information such as education, experience, skills,
//             certifications, salary expectations, and job preferences.
//           </li>
//           <li>
//             Recruiter or employer information including company details and job
//             postings.
//           </li>
//           <li>
//             Technical data such as IP address, device identifiers, browser type,
//             operating system, and activity logs.
//           </li>
//           <li>
//             Communication data including messages, feedback, and support
//             interactions.
//           </li>
//         </ul>
//       </section>

//       {/* USE OF INFORMATION */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">
//           3. How We Use Your Personal Information
//         </h2>
//         <p className="mb-2">
//           Personal Information is processed lawfully and fairly for the
//           following purposes:
//         </p>

//         <ul className="list-disc ml-5 space-y-1">
//           <li>Account creation and management.</li>
//           <li>Job applications and recruiter interactions.</li>
//           <li>Sending job alerts, notifications, and system updates.</li>
//           <li>Improving platform performance and user experience.</li>
//           <li>Preventing fraud and ensuring platform security.</li>
//           <li>Compliance with legal and regulatory obligations.</li>
//         </ul>
//       </section>

//       {/* COOKIES */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">
//           4. Cookies and Tracking Technologies
//         </h2>
//         <p>
//           Hirees uses cookies and similar technologies to maintain sessions,
//           remember user preferences, analyze traffic, and improve Platform
//           functionality. Disabling cookies may limit certain features.
//         </p>
//       </section>

//       {/* LEGAL BASIS */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">
//           5. Legal Basis for Processing
//         </h2>
//         <ul className="list-disc ml-5 space-y-1">
//           <li>User consent.</li>
//           <li>Performance of contractual obligations.</li>
//           <li>Compliance with applicable laws.</li>
//           <li>Legitimate business interests.</li>
//         </ul>
//       </section>

//       {/* SHARING */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">
//           6. Information Sharing and Disclosure
//         </h2>
//         <p className="mb-2">
//           Hirees does not sell Personal Information. Data may be shared:
//         </p>
//         <ul className="list-disc ml-5 space-y-1">
//           <li>With recruiters or employers.</li>
//           <li>With service providers bound by confidentiality.</li>
//           <li>With authorities when legally required.</li>
//           <li>During business transfers or restructuring.</li>
//         </ul>
//       </section>

//       {/* RETENTION */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">7. Data Retention</h2>
//         <p>
//           Personal Information is retained only as long as necessary for
//           service delivery, legal compliance, and dispute resolution.
//         </p>
//       </section>

//       {/* USER RIGHTS */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">8. Your Rights</h2>
//         <p>
//           You may access, correct, update, or delete your Personal Information,
//           subject to applicable laws.
//         </p>
//       </section>

//       {/* SECURITY */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">9. Data Security</h2>
//         <p>
//           Reasonable technical and organizational safeguards are used to protect
//           Personal Information; however, absolute security cannot be guaranteed.
//         </p>
//       </section>

//       {/* CHILDREN */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">
//           10. Children’s Privacy
//         </h2>
//         <p>
//           The Platform is intended for users aged 18 years and above.
//         </p>
//       </section>

//       {/* CHILDREN */}
//       <section className="mb-4">
//         <h2 className="text-base font-semibold mb-1">
//           11. Disclaimer
//         </h2>
//         <p>
//           Fstone Technologies does not store any payment-related information such as credit card, debit card, or banking details on the Hirees Platform. Any payments, where applicable, are processed through secure third-party payment gateways. Fstone Technologies shall not be responsible or liable for any loss, damage, or unauthorized disclosure arising from payment transactions conducted through such third-party services.
//             If any Personal Information is voluntarily shared by you with Fstone Technologies that is not specifically requested during registration or use of the Platform (whether mandatory or optional), Fstone Technologies shall not be held liable for any security breach, misuse, or disclosure of such information.
//             If you have any questions, concerns, or complaints regarding this Privacy Policy or the protection of your Personal Information, you may contact the our contact email provided below. We will make reasonable efforts to address your concerns and resolve any issues in a timely manner.
//         </p>
//       </section>

//       {/* CONTACT */}
//       <section>
//         <h2 className="text-base font-semibold mb-1">
//           11. Contact Information
//         </h2>
//         <p>
//           For questions or concerns regarding this Privacy Policy, contact:
//         </p>
//         <p className="font-medium">
//           info@fstonetechnologies.com
//         </p>
//       </section>
//     </div>
//   );
// };

// export default PrivacyPolicy;






import React from "react";
import logo from "@/assets/fstonelogo.png";

const PrivacyPolicy = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-[1fr_260px] gap-6">

        {/* LEFT CONTENT */}
        <main className="text-gray-800 text-sm leading-snug">
          <h1 className="text-2xl font-semibold mb-4">Privacy Policy</h1>

          {/* 1. INTRODUCTION */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">1. Introduction</h2>
            <p className="mb-2">
              Fstone Technologies operates the job portal application known as{" "}
              <strong>Hirees</strong> (“Platform”). We are committed to
              respecting your privacy and protecting the personal information
              that you share with us.
            </p>
            <p className="mb-2">
              This Privacy Policy explains how we collect, use, store, process,
              disclose, and protect personal information when you access or use
              Hirees through our website, mobile applications, or related
              services.
            </p>
            <p>
              By accessing or using the Platform, you agree to the terms of this
              Privacy Policy. If you do not agree, you should discontinue use of
              the Platform.
            </p>
          </section>

          {/* 2. INFORMATION COLLECTED */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              2. Types of Personal Information We Collect
            </h2>
            <p className="mb-2">
              Personal Information refers to any information that identifies or
              can reasonably identify an individual. Depending on how you
              interact with Hirees, we may collect:
            </p>
            <ul className="list-disc ml-5 space-y-1">
              <li>
                Personal details such as full name, email address, mobile number,
                encrypted password, city, state, and country.
              </li>
              <li>
                Resume and profile information including education, work
                experience, skills, certifications, salary expectations, and
                employment preferences.
              </li>
              <li>
                Recruiter or employer information such as company name,
                designation, official contact details, and job postings.
              </li>
              <li>
                Technical data including IP address, browser type, operating
                system, device identifiers, login timestamps, and usage logs.
              </li>
              <li>
                Communication data including messages exchanged between job
                seekers and recruiters, feedback, and support interactions.
              </li>
            </ul>
          </section>

          {/* 3. USE OF INFORMATION */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              3. How We Use Your Personal Information
            </h2>
            <p className="mb-2">
              Personal Information is processed lawfully, fairly, and
              transparently for the following purposes:
            </p>
            <ul className="list-disc ml-5 space-y-1">
              <li>Creating and managing user accounts on Hirees.</li>
              <li>
                Enabling job applications, recruiter discovery, and candidate
                shortlisting.
              </li>
              <li>
                Sending job alerts, notifications, system updates, and important
                communications.
              </li>
              <li>
                Improving platform functionality, analytics, performance, and
                user experience.
              </li>
              <li>
                Preventing fraud, unauthorized access, and misuse of the
                Platform.
              </li>
              <li>
                Complying with legal obligations, regulatory requirements, and
                enforcing Terms of Use.
              </li>
            </ul>
          </section>

          {/* 4. COOKIES */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              4. Cookies and Tracking Technologies
            </h2>
            <p>
              Hirees uses cookies and similar tracking technologies to maintain
              sessions, remember user preferences, analyze traffic, and improve
              Platform functionality. Disabling cookies may limit certain
              features.
            </p>
          </section>

          {/* 5. LEGAL BASIS */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              5. Legal Basis for Processing
            </h2>
            <ul className="list-disc ml-5 space-y-1">
              <li>User consent.</li>
              <li>Performance of contractual obligations.</li>
              <li>Compliance with applicable laws.</li>
              <li>Legitimate business interests.</li>
            </ul>
          </section>

          {/* 6. INFORMATION SHARING */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              6. Information Sharing and Disclosure
            </h2>
            <p className="mb-2">
              Hirees does not sell Personal Information. Data may be shared:
            </p>
            <ul className="list-disc ml-5 space-y-1">
              <li>With recruiters or employers.</li>
              <li>With service providers bound by confidentiality.</li>
              <li>With authorities when legally required.</li>
              <li>During business transfers or restructuring.</li>
            </ul>
          </section>

          {/* 7. DATA RETENTION */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              7. Data Retention
            </h2>
            <p>
              Personal Information is retained only for as long as necessary for
              service delivery, legal compliance, and dispute resolution.
            </p>
          </section>

          {/* 8. USER RIGHTS */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              8. Your Rights
            </h2>
            <p>
              You may access, correct, update, or delete your Personal
              Information, subject to applicable laws.
            </p>
          </section>

          {/* 9. DATA SECURITY */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              9. Data Security
            </h2>
            <p>
              Reasonable administrative, technical, and organizational
              safeguards are used to protect Personal Information; however,
              absolute security cannot be guaranteed.
            </p>
          </section>

          {/* 10. CHILDREN */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              10. Children’s Privacy
            </h2>
            <p>
              The Platform is intended only for users aged 18 years and above.
            </p>
          </section>

          {/* 11. DISCLAIMER */}
          <section className="mb-4">
            <h2 className="text-base font-semibold mb-1">
              11. Disclaimer
            </h2>
            <p>
              Fstone Technologies does not store any payment-related information
              such as credit card, debit card, or banking details on the Hirees
              Platform. Payments, where applicable, are processed through secure
              third-party payment gateways. Fstone Technologies shall not be
              liable for any loss or damage arising from such transactions.
            </p>
            <p className="mt-1">
              If any Personal Information is voluntarily shared by you that is
              not specifically requested, Fstone Technologies shall not be held
              responsible for any misuse or disclosure of such information.
            </p>
          </section>

          {/* 12. CONTACT */}
          <section>
            <h2 className="text-base font-semibold mb-1">
              12. Contact Information
            </h2>
            <p className="font-medium">
              info@fstonetechnologies.com
            </p>
          </section>
        </main>

        {/* RIGHT LOGO */}
        <aside className="md:sticky md:top-24 h-fit flex justify-center md:justify-end">
          <div className="text-center">
            <img
              src={logo}
              alt="Fstone Technologies"
              className="w-48 object-contain mx-auto"
            />
            
          </div>
        </aside>

      </div>
    </div>
  );
};

export default PrivacyPolicy;
